import React, { useEffect } from 'react';
import styled from 'styled-components';
import TokenomicsChart from '../components/mavrkToken/TokenomicsChart';
import WhitepaperSummary from '../components/mavrkToken/WhitepaperSummary';
import { MAVRK_TOKEN_DISTRIBUTION } from '../constants/mavrkTokenomics';
import { PageShell } from '../components/shared/PageShell';

const PageTitle = styled.h1`
  font-size: 40px;
  font-weight: 700;
  color: #ffffff;
  margin: 0 0 8px 0;
  font-family: 'Inter', sans-serif;
  text-align: center;
  
  @media (max-width: 768px) {
    font-size: 32px;
  }
`;

const PageSubtitle = styled.p`
  font-size: 18px;
  color: rgba(255, 255, 255, 0.7);
  margin: 0 0 40px 0;
  text-align: center;
  font-family: 'Inter', sans-serif;
  
  @media (max-width: 768px) {
    font-size: 16px;
    margin-bottom: 32px;
  }
`;

const ContentGrid = styled.div`
  display: grid;
  grid-template-columns: minmax(0, 1.1fr) minmax(0, 1fr);
  gap: 32px;
  margin-top: 40px;
  
  @media (max-width: 1024px) {
    grid-template-columns: 1fr;
    gap: 24px;
  }
`;

const GlassCard = styled.div`
  background: linear-gradient(135deg, 
    rgba(42, 31, 61, 0.6) 0%, 
    rgba(30, 20, 45, 0.6) 100%
  );
  border: 1px solid rgba(168, 85, 247, 0.3);
  border-radius: 20px;
  padding: 32px;
  backdrop-filter: blur(12px);
  box-shadow: 
    0 8px 24px rgba(88, 28, 135, 0.25),
    0 0 0 1px rgba(168, 85, 247, 0.2);
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  
  &:hover {
    border-color: rgba(168, 85, 247, 0.5);
    box-shadow: 
      0 12px 32px rgba(88, 28, 135, 0.35),
      0 0 0 1px rgba(168, 85, 247, 0.3);
    transform: translateY(-2px);
  }
  
  @media (max-width: 768px) {
    padding: 24px;
    border-radius: 16px;
  }
`;

const CardTitle = styled.h2`
  font-size: 24px;
  font-weight: 600;
  color: #ffffff;
  margin: 0 0 8px 0;
  font-family: 'Inter', sans-serif;
  
  @media (max-width: 768px) {
    font-size: 20px;
  }
`;

const CardSubtitle = styled.p`
  font-size: 14px;
  color: rgba(255, 255, 255, 0.6);
  margin: 0 0 32px 0;
  font-family: 'Inter', sans-serif;
`;

const ChartCardContent = styled.div`
  min-height: 500px;
  
  @media (max-width: 768px) {
    min-height: 400px;
  }
  
  @media (max-width: 480px) {
    min-height: 350px;
  }
`;

const SummaryCardContent = styled.div`
  min-height: 400px;
  
  @media (max-width: 768px) {
    min-height: auto;
  }
`;

const MavrkTokenPage: React.FC = () => {
  useEffect(() => {
    document.title = 'MAVRK Token - Autonomous Ecosystem Index | Mavrk';
  }, []);

  return (
    <PageShell>
      <PageTitle>MAVRK Token</PageTitle>
      <PageSubtitle>
        The Autonomous Ecosystem Index & Recursive Liquidity Engine
      </PageSubtitle>

      <ContentGrid>
        <GlassCard>
          <CardTitle>MAVRK Token Supply</CardTitle>
          <CardSubtitle>Interactive breakdown of MAVRK tokenomics</CardSubtitle>
          <ChartCardContent>
            <TokenomicsChart data={MAVRK_TOKEN_DISTRIBUTION} />
          </ChartCardContent>
        </GlassCard>

        <GlassCard>
          <CardTitle>What is the MAVRK Token?</CardTitle>
          <CardSubtitle>Understanding the ecosystem index fund</CardSubtitle>
          <SummaryCardContent>
            <WhitepaperSummary />
          </SummaryCardContent>
        </GlassCard>
      </ContentGrid>
    </PageShell>
  );
};

export default MavrkTokenPage;

